function calcScrollerHeight(el, endEl){
  let fixedEl = document.getElementsByClassName(el)[0]
  let footer = document.getElementsByClassName(endEl)[0]
  if (fixedEl && footer){
    let height = footer.getBoundingClientRect().top - fixedEl.getBoundingClientRect().top
    fixedEl.style.height = height + 'px'
  }
}

// скрипт используется в блоге
window.addEventListener('resize', () =>{
  calcScrollerHeight('blog_control_scroller', 'footer');
});

window.addEventListener('load', () =>
{
  calcScrollerHeight('blog_control_scroller', 'footer');
});